import React from "react";
import TrapTrailersGrid from "./Grid";
import Footer from "../../components/Footer";
import CancelButton from "../../components/Buttons/CancelButton";
import BackButton from "../../components/Buttons/BackButton";
import { redirectToIBPlanning } from "../../utils";
import withRouter from "../../../../../routes/withRouter";
import { Button } from "@material-ui/core";
class Traps extends React.Component {
  constructor(props) {
    super(props);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  onCellClicked = (params) => {
    const column = params.colDef?.colId;
    if (column === "totalBills") {
      this.props.showTrapBills(params.data);
      return;
    }
    if (column === "batchCheckbox") {
      this.gridApi.refreshCells({ columns: ["batchCheckbox"] });
      this.props.updateSelectedBatches(params.data);
    }
  };

  render() {
    const disableActionButton = !this.props.data;
    return (
      <>
        <TrapTrailersGrid
          rowData={this.props.data}
          onGridReady={this.onGridReady}
          glEventHub={this.props.glEventHub}
          onCellClicked={this.onCellClicked}
          gridApi={this.gridApi}
        />
        <Footer>
          <CancelButton onClick={redirectToIBPlanning(this.props.router.navigate)} />
          <BackButton
            onClick={this.props.goBack}
            disabled={disableActionButton}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={this.props.handleSubmit}
            disabled={disableActionButton}
          >
            Done
          </Button>
        </Footer>
      </>
    );
  }
}

export default withRouter(Traps);
